import { render, staticRenderFns } from "./Inventoryquery.vue?vue&type=template&id=0509357d&"
import script from "./Inventoryquery.vue?vue&type=script&lang=js&"
export * from "./Inventoryquery.vue?vue&type=script&lang=js&"
import style0 from "./Inventoryquery.vue?vue&type=style&index=0&id=0509357d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports